import React from 'react';
import PropTypes from 'prop-types';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_2CBlue_2BRed = () => <CrossRoad coords="1373.000000, 777.000000"/>;
export default CrossRoad_2CBlue_2BRed;
